import { motion, useMotionValue, useTransform, animate } from "motion/react";
import { useEffect } from "react";

type StatItem = {
  label: string;
  value: number;
  accent: string;
};

const stats: StatItem[] = [
  { label: "Surfaces", value: 14, accent: "mint" },
  { label: "Plugins", value: 38, accent: "violet" },
  { label: "Tests", value: 127, accent: "cyan" },
  { label: "Providers", value: 6, accent: "amber" },
];

function AnimatedNumber({ value, accent }: { value: number; accent: string }) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.round(v));

  useEffect(() => {
    const controls = animate(count, value, {
      duration: 1.8,
      ease: "easeOut",
    });
    return controls.stop;
  }, [count, value]);

  return (
    <motion.span className={`stat-counter__value stat-counter__value--${accent}`}>
      {rounded}
    </motion.span>
  );
}

export function StatCounters() {
  return (
    <div className="stat-counters">
      {stats.map((stat) => (
        <motion.div
          key={stat.label}
          className="stat-counter"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: stats.indexOf(stat) * 0.1 }}
        >
          <AnimatedNumber value={stat.value} accent={stat.accent} />
          <span className="stat-counter__label">{stat.label}</span>
          <div className={`stat-counter__bar stat-counter__bar--${stat.accent}`}>
            <motion.div
              className="stat-counter__bar-fill"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.2, delay: 0.4 + stats.indexOf(stat) * 0.1, ease: "easeOut" }}
            />
          </div>
        </motion.div>
      ))}
    </div>
  );
}
